/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import { useEffect, useState } from "react";
import { useAtom } from "jotai";
import { DeleteIcon } from "@chakra-ui/icons";
import {
  InputGroup,
  Box,
  IconButton,
  VStack,
  Grid,
  GridItem,
} from "@chakra-ui/react";

import Spinner from "../../../Spinner";
import ButtonUI from "../../../ButtonUI";
import { FormGroup } from "../../Elements/FormGroup";
import { FieldSelect } from "../../Elements/FieldSelect";
import { FieldInput } from "../../Elements/FieldInput";
import { SwitchInput } from "../../Elements/FieldSwitcher";

import { elementAtom } from "../../../../state/FormGeneratorState/elmentAtom";
import { filterInputs } from "../../../../helper/FormGeneratorHelper/conditionalLogic";
import { useField } from "../../../../hooks/FormGeneratorHooks";
import { useRepeater } from "../../../../hooks/FormGeneratorHooks/useRepeater";
import { conditionsListExport } from "../PropertyPageEditor/conditionList";
import { useTranslation } from "react-i18next";

const ConditionLogic = (props) => {
  const {
    errorMessage,
    id,
    isValid,
    isSubmitted,
    resetKey,
    setValue,
    value,
    otherProps,
  } = useField(props);
  const { t } = useTranslation() as any;
  const { required, name } = props;
  const { children, label, type, placeholder, helper, ...rest } = otherProps;
  const [isTouched, setIsTouched] = useState(false);
  const showError = !isValid && (isTouched || isSubmitted);
  const [atomElment] = useAtom(elementAtom);

  const arr = filterInputs(props.elements, atomElment);
  useEffect(() => {
    setIsTouched(false);
  }, [resetKey]);

  const options = arr.map((elem, i) => {
    if (
      props.value.operator === "all" &&
      props.value.conditions.find((e) => e.filedTocompare === elem.field_name)
    ) {
      return {
        label: `${elem.label + "-" + i}`,
        value: elem.field_name,
        disabled: true,
      };
    } else {
      return { label: `${elem.label + "-" + i}`, value: elem.field_name };
    }
  });
  const formGroupProps = {
    errorMessage,
    helper,
    id,
    isRequired: !!required,
    label,
    showError,
    name,
    ...rest,
  };
  const verifOption = () => {
    let i = 0;
    options.map((opt) => {
      if (opt.disabled) {
        i++;
      }
    });
    if (
      i == options.length ||
      (props.value.operator === "all" &&
        props.form.values["conditionLogic"].conditions.length >= options.length)
    ) {
      return true;
    } else return false;
  };

  const collection = useRepeater({
    name: "conditionLogic.conditions",
    form: props.form,
    initialValues: props.value.conditions,
  });
  const conditionsList = conditionsListExport(t);

  useEffect(() => {
    setValue(props.value);
  }, []);
  useEffect(() => {
    setValue((val) => {
      return { ...val, conditions: value.conditions };
    });
  }, [collection.length]);
  return (
    <>
      {value && value.conditions ? (
        <>
          <FormGroup {...formGroupProps}>
            <InputGroup name="conditionLogic">
              <VStack
                spacing={4}
                align="start"
                className="border p-4 rounded-lg w-full "
              >
                <Grid
                  width={"60%"}
                  templateColumns="repeat(2, 1fr)"
                  alignItems={"baseline"}
                  gap={1}
                >
                  <GridItem w="170px" h="10">
                    {" "}
                    <span style={{ fontSize: "16px" }} className="font-bold ">
                      {t("Survey.ConditionalLogic")}
                    </span>
                  </GridItem>
                  <GridItem
                    w="100%"
                    h="10"
                    className="flex  text-xs text-gray-500  "
                  >
                    <GridItem>
                      <span className="p-2 card-subtitle">
                        {" "}
                        {t("Survey.Deactivate")}{" "}
                      </span>
                    </GridItem>
                    <GridItem>
                      {" "}
                      <SwitchInput
                        value={props.value.status}
                        name="conditionLogic.status"
                      />
                    </GridItem>
                    <GridItem>
                      <span className="p-2 card-subtitle">
                        {" "}
                        {t("Survey.Activate")}
                      </span>
                    </GridItem>
                  </GridItem>
                </Grid>
                {props.form.values.conditionLogic &&
                  props.form.values.conditionLogic.status && (
                    <>
                      <Grid
                        templateColumns="repeat(5, 0.6fr)"
                        alignItems={"baseline"}
                        gap={0}
                      >
                        {" "}
                        <GridItem w={16} h="10">
                          <span> {t("Survey.Action")} </span>
                        </GridItem>
                        <GridItem w="100%" h="10">
                          {" "}
                          <FieldSelect
                            w={32}
                            name="conditionLogic.action"
                            value={
                              Array.isArray(props.value.action)
                                ? "S"
                                : props.value.action
                            }
                            // placeholder="action"
                            style={{ borderRadius: "10px", height: "auto" }}
                            dropdownStyle={{
                              borderRadius: "10px",
                              padding: "4%",
                            }}
                            className="border rounded-lg h-full  "
                            options={[
                              {
                                label: t("SurveyIntl.show"),
                                value: "S",
                              },
                              {
                                label: t("SurveyIntl.hide"),
                                value: "H",
                              },
                            ]}
                          />
                        </GridItem>
                        <GridItem mx={1} h="10">
                          {" "}
                          <span className="mb-4 flexCenter ">
                            {t("SurveyIntl.when")}{" "}
                          </span>
                        </GridItem>
                        <GridItem w={32} h="10">
                          {" "}
                          <FieldSelect
                            name="conditionLogic.operator"
                            value={
                              Array.isArray(props.value.operator)
                                ? "S"
                                : props.value.operator
                            }
                            style={{ borderRadius: "10px", height: "auto" }}
                            dropdownStyle={{
                              borderRadius: "10px",
                              padding: "4%",
                            }}
                            className="border rounded-lg h-full"
                            options={[
                              {
                                label: t("SurveyIntl.all"),
                                value: "all",
                              },
                              {
                                label: t("SurveyIntl.one"),
                                value: "one",
                              },
                            ]}
                          />
                        </GridItem>
                        <GridItem w={56} h="10">
                          {" "}
                          <p className="ml-3">
                            {" "}
                            {t("SurveyIntl.conditionsAreValid")}
                          </p>
                        </GridItem>
                      </Grid>
                      <Grid
                        templateColumns="repeat(3, 1fr)"
                        gap={1}
                        className="text-xs"
                      >
                        {collection.keys.map((key, index) => (
                          <>
                            <GridItem>
                              <Box flex="1">
                                <FieldSelect
                                  name={`conditionLogic.conditions[${index}].fieldToCompare`}
                                  required
                                  value={
                                    props.value.conditions[index]?.[
                                      "fieldToCompare"
                                    ]
                                  }
                                  label="Champ à comparer "
                                  options={options}
                                  m="0"
                                />
                              </Box>
                            </GridItem>
                            <GridItem>
                              {" "}
                              <Box flex="1">
                                <FieldSelect
                                  name={`conditionLogic.conditions[${index}].ifCondition`}
                                  required
                                  value={
                                    props.value.conditions[index]?.[
                                      "ifCondition"
                                    ]
                                  }
                                  label="Condition"
                                  m="0"
                                  options={conditionsList}
                                />
                              </Box>
                            </GridItem>
                            <GridItem className="flex">
                              <Box flex="1">
                                <FieldInput
                                  name={`conditionLogic.conditions[${index}].value`}
                                  required
                                  value={
                                    props.value.conditions[index]?.["value"]
                                  }
                                  placeholder={t("Survey.Value")}
                                  w={32}
                                  label={t("Survey.Value")}
                                  m="0"
                                />
                              </Box>{" "}
                              <Box pt="1.8rem" mx={0.5}>
                                <IconButton
                                  size="sm"
                                  aria-label="Delete"
                                  icon={<DeleteIcon />}
                                  onClick={() => {
                                    collection.remove(index);

                                    setValue((current) => {
                                      return {
                                        ...current,
                                        conditions: current.conditions.splice(
                                          index,
                                          1
                                        ),
                                      };
                                    });
                                  }}
                                />
                              </Box>
                            </GridItem>
                          </>
                        ))}

                        <Box>
                          {collection.length <= 20 && (
                            <>
                              {!(options.length < 1 || verifOption()) && (
                                <ButtonUI
                                  status="secondary"
                                  className="p-2 text-xs w-48"
                                  type="button"
                                  onClick={() => collection.append()}
                                >
                                  {" "}
                                  {t("Survey.AddCondition")}{" "}
                                </ButtonUI>
                              )}
                            </>
                          )}
                        </Box>
                      </Grid>
                    </>
                  )}
              </VStack>
            </InputGroup>
          </FormGroup>
        </>
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default ConditionLogic;
